<template>
  <v-dialog v-model="alertDialog" persistent max-width="350">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>
        {{content}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" variant="text" @click="closeDialog()">
          {{closeBtnLabel}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AlertDialog',

  data: () => ({
    alertDialog: false,
    title: '',
    content: '',
    closeBtnLabel: ''
  }),

  computed: {
    ...mapGetters('alertDialogModule', ['isDialogActived'])
  },

  watch: {
    'isDialogActived': function (newValue, oldValue) {
      if (newValue) {
        this.setData()
      }
      this.alertDialog = newValue
    }
  },

  methods: {
    setData () {
      let data = this.$store.getters['alertDialogModule/getData']
      this.title = data.title
      this.content = data.content
      this.closeBtnLabel = data.closeBtnLabel
    },

    closeDialog () {
      this.$store.dispatch('alertDialogModule/setDialogActivedFalse')
      this.title = ''
      this.content = ''
      this.closeBtnLabel = ''
    }
  }

}
</script>
